<mat-card class="mat-card-user-detail">
  <mat-card-header>
    <mat-card-title>{{ 'label.material' | translate }}</mat-card-title>
    <mat-card-subtitle *ngIf="!data?.id">{{ 'label.creation' | translate }}</mat-card-subtitle>
    <mat-card-subtitle *ngIf="data?.id">{{ 'label.edition' | translate }}</mat-card-subtitle>
  </mat-card-header>
  <form [formGroup]="materialForm" (ngSubmit)="onSubmit()">
    <mat-card-content>
      <div class="content-row">
        <label class="content-row-label">{{ 'label.name' | translate }}</label>
        <mat-form-field class="content-row-input">
          <input matInput formControlName="name" type="text" autocomplete="off">
        </mat-form-field>
      </div>
      <div class="content-row">
        <label class="content-row-label">{{ 'label.dangerousProduit' | translate }}</label>
        <mat-checkbox [(ngModel)]="isDangerousProduct" [ngModelOptions]="{standalone: true}">
        </mat-checkbox>

      </div>
      <div class="content-row" style="height: 110px;">
        <label class="content-row-label">{{ 'label.dangerousLevel' | translate }}</label>
        <!-- <mat-form-field class="content-row-input">
          <input #modValue type="number" formControlName="dangerousLevel" matInput>
        </mat-form-field> -->
        <mat-slider class="content-row-input"  [disabled]="!isDangerousProduct"
        [(ngModel)]="dangerousLevel" [ngModelOptions]="{standalone: true}" max="3" min="0" step="1" thumbLabel="true">
        </mat-slider>
      </div>
    </mat-card-content>
    <mat-card-actions class="report-error-card-action">
      <button mat-raised-button color="warn" type="button" (click)="onCancel()">
        <mat-icon>clear</mat-icon> {{ 'button.cancel' | translate }}
      </button>
      <button mat-raised-button color="primary" [disabled]="materialForm.invalid">
        <mat-icon>save</mat-icon> {{ 'button.save' | translate }}
      </button>
    </mat-card-actions>
  </form>
</mat-card>